import {createContext, FC, PropsWithChildren, useContext, useMemo} from "react";
import {useMercureSubscriber} from "../hooks/useMercureSubscriber";

interface EventContexteInterface {
    newExecutions: object;
    newSavs: object;
    newBanners: object;
    newMessages: object;
    accessoriesNotifications: object;
}
export const EventContextProvider = createContext<EventContexteInterface>({});

export const EventProvider: FC<PropsWithChildren> = ({children}) => {
    const {result: newExecutions} = useMercureSubscriber(['/orders/news']);
    const {result: newSavs} = useMercureSubscriber(['/savs/news']);
    const {result: newBanners} = useMercureSubscriber(['/banners/news'], false);
    const {result: newMessages} = useMercureSubscriber(['/messages/news'], false);
    const {result: accessoriesNotifications} = useMercureSubscriber(['/stock/accessories/notifications']);
    const context = useMemo(
        () => ({
            newExecutions,
            newSavs,
            newBanners,
            newMessages,
            accessoriesNotifications,
        }),
        [
            newExecutions,
            newSavs,
            newBanners,
            newMessages,
            accessoriesNotifications,
        ],
    )

    return <EventContextProvider.Provider value={context}>{children}</EventContextProvider.Provider>
}

export function useEventProvider(): EventContexteInterface {
    return useContext(EventContextProvider);
}